/** @jsx jsx */
import { jsx } from "theme-ui"
import { articleStyles } from "@src/theme"
import ButtonLink from "@components/ButtonLink"


const MarkdownBody = ({ html, ...props }) => (
  <div
    dangerouslySetInnerHTML={{ __html: html }}
    sx={{
      ...articleStyles,
      ".buttonLink": {
        variant: "buttons.primary",
        color: "white",
        bg: 'darkPurple',
        textDecoration: "none",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
          bg: "purple",
          color: "white",
        },
        height: "unset",
        transition: "all 0s ease 0s",
        lineHeight: "unset",
        borderRadius: "unset",
      }
    }}
    {...props}
  />
)

export default MarkdownBody
